import { verifyLicense, parseDocDate } from './licenseUtils';
import { jwtDecode } from 'jwt-decode';

jest.mock('jwt-decode', () => ({
    jwtDecode: jest.fn(),
}));

describe('licenseUtils', () => {
    const mockJwtDecode = jwtDecode as jest.Mock;

    beforeEach(() => {
        jest.clearAllMocks();
    });

    describe('parseDocDate', () => {
        it('should correctly parse dd.mm.yyyy format', () => {
            const date = parseDocDate('26.07.2023');
            expect(date?.getFullYear()).toBe(2023);
            expect(date?.getMonth()).toBe(6); // July is 6 (0-indexed)
            expect(date?.getDate()).toBe(26);
        });

        it('should return null for invalid format', () => {
            expect(parseDocDate('')).toBeNull();
            expect(parseDocDate('2023.01.01')).toBeNull();
        });
    });

    describe('verifyLicense', () => {
        const now = new Date('2023-08-01').getTime();

        it('should return true for valid standard JWT (iat based on exp)', () => {
            mockJwtDecode.mockReturnValue({
                exp: (now / 1000) + 1000,
            });
            expect(verifyLicense('some-token', now)).toBe(true);
        });

        it('should return false for expired standard JWT', () => {
            mockJwtDecode.mockReturnValue({
                exp: (now / 1000) - 1000,
            });
            expect(verifyLicense('some-token', now)).toBe(false);
        });

        it('should return true for valid doc-format license (iat check)', () => {
            // startDate: 26.07.2023, endDate: 26.09.2023, iat: 26 * 26 = 676
            mockJwtDecode.mockReturnValue({
                startDate: '26.07.2023',
                endDate: '26.09.2023',
                iat: 676,
            });
            expect(verifyLicense('doc-token', now)).toBe(true);
        });

        it('should return false for valid dates but wrong iat', () => {
            mockJwtDecode.mockReturnValue({
                startDate: '26.07.2023',
                endDate: '26.09.2023',
                iat: 123, // Wrong iat
            });
            expect(verifyLicense('doc-token', now)).toBe(false);
        });

        it('should return false if current time is before startDate', () => {
            const wayBefore = new Date('2022-01-01').getTime();
            mockJwtDecode.mockReturnValue({
                startDate: '26.07.2023',
                endDate: '26.09.2023',
                iat: 676,
            });
            expect(verifyLicense('doc-token', wayBefore)).toBe(false);
        });

        it('should return false if current time is after endDate', () => {
            const wayAfter = new Date('2024-01-01').getTime();
            mockJwtDecode.mockReturnValue({
                startDate: '26.07.2023',
                endDate: '26.09.2023',
                iat: 676,
            });
            expect(verifyLicense('doc-token', wayAfter)).toBe(false);
        });
        
        it('should return false for empty license text', () => {
            expect(verifyLicense('')).toBe(false);
        });
    });
});
